/**
 * Mobile Menu Component
 * ハンバーガーメニューの開閉制御
 */
export default function initMobileMenu() {
  const toggles = document.querySelectorAll('.js-hamburger');
  const drawer = document.getElementById('mobile-menu-content');
  const html = document.documentElement;

  if (!toggles.length || !drawer) return;

  toggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      const nextState = !isExpanded;

      // ボタンの状態変更
      toggles.forEach(btn => {
        btn.setAttribute('aria-expanded', nextState);
        btn.classList.toggle('is-active', nextState);
      });

      // ドロワーの状態変更
      drawer.classList.toggle('is-active', nextState);
      html.classList.toggle('is-drawer-open', nextState);
    });
  });

  // 画面外クリックやEscキーでの閉じる処理などは必要に応じて追加
}